enum GenderEnum {
  COMPANY = 'company',
  FEMALE = 'female',
  MALE = 'male'
}

export default GenderEnum;
